import React from "react";
import { Link } from "react-router-dom";

import Logo from "../../assets/user/images/logo.svg";
import providerRoutes from "../../utlis/provider/routes.utlis.js";
import { routes } from "../../utlis/user/routes.utlis";

const Header = () => {
  return (
    <>
      <div className="header">
        <div className="top-header">
          <div className="container">
            <div className="top-header-content">
              <div className="logo">
                <Link to={routes.home}>
                  <img src={Logo} alt="logo" />
                </Link>
              </div>
              <div className="header-right-nav text-right">
                <ul className="navbar-nav">

                  <li className="nav-item dropdown">
                    <Link className="nav-link btnLogin" to={routes.login}>
                      Login
                    </Link>
                  </li>
                  <li className="nav-item dropdown">
                    <Link className="nav-link btnjoincare" to={routes.signup}>
                      Sign Up
                    </Link>
                  </li>

                  <li className="nav-item dropdown">
                    <Link className="nav-link btnjoincare" to={providerRoutes.routes.providerRegister}>
                      Join Care Provider Network
                    </Link>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
